import { SidenavIcon, SidenavRow } from '@app/components/layout/sidenav/base';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export function AdminIndicator() {
  return (
    <SidenavRow>
      <SidenavIcon data-cy="auth-client-logo">
        <ManageAccountsIcon />
      </SidenavIcon>
      <Typography
        component="div"
        data-cy="auth-client-name"
        sx={{
          color: '#dee2e6',
          textTransform: 'uppercase',
          fontWeight: 500,
          alignSelf: 'center',
          fontSize: '1rem',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        <FormattedMessage id="core.sidenav.adminIndicatorText" defaultMessage="Admin" />
      </Typography>
    </SidenavRow>
  );
}
